import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = { class: "details-panel-content-wrapper" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "bt-icon bt-icon--xs" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = {
  key: 0,
  class: "no-badge text-center"
}
const _hoisted_9 = { class: "text-gray" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { class: "text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_BadgeItem = _resolveComponent("BadgeItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogAddBadge = _resolveComponent("DialogAddBadge")
  const _component_DialogMaxEntity = _resolveComponent("DialogMaxEntity")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, [
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("entrancePlant.associatedBadges")), 1),
            _createVNode(_component_Button, {
              disabled: _ctx.disabled,
              class: "p-button-rounded p-button-outlined ml-auto",
              onClick: _ctx.handleAddBadgeResident
            }, {
              default: _withCtx(() => [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                    require(`@/assets/images/icons/icon-plus-outline.svg`)
                                ,
                    "aria-label": "icon-grid"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        _createVNode(_component_ElScrollbar, { class: "details-panel-content mt-3" }, {
          default: _withCtx(() => [
            (_ctx.badgesList.length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.noBadgeText[0]), 1),
                  _hoisted_10,
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.noBadgeText[1]), 1)
                ]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.badgesList, (badge, index) => {
                  return (_openBlock(), _createBlock(_component_BadgeItem, {
                    key: index,
                    disabled: _ctx.disabled,
                    badgeTab: "",
                    badge: badge,
                    class: "m-3 py-2",
                    onDeleteBadge: ($event: any) => (_ctx.removeBadge(badge))
                  }, null, 8, ["disabled", "badge", "onDeleteBadge"]))
                }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.isVisibleAddBadge)
      ? (_openBlock(), _createBlock(_component_DialogAddBadge, {
          key: 0,
          residentBadge: "",
          "is-visible": _ctx.isVisibleAddBadge,
          plantBadges: _ctx.plantBadges,
          fromResidentTab: _ctx.editingApartment,
          onAddBadgeTab: _ctx.addBadge,
          onHideDialog: _ctx.handleAddBadgeResident
        }, null, 8, ["is-visible", "plantBadges", "fromResidentTab", "onAddBadgeTab", "onHideDialog"]))
      : _createCommentVNode("", true),
    (_ctx.isVisibleMaxEntity)
      ? (_openBlock(), _createBlock(_component_DialogMaxEntity, {
          key: 1,
          "is-visible": _ctx.isVisibleMaxEntity,
          title: _ctx.$t('AppResource.Warning'),
          message: _ctx.$t('entrancePlant.popupMessageMaxBadgesReachedWarning'),
          onHideDialog: _ctx.handleMaxEntityDialog
        }, null, 8, ["is-visible", "title", "message", "onHideDialog"]))
      : _createCommentVNode("", true)
  ], 64))
}